import "../css/card_design.css";
import "../css/Nav design.css";
import EducationDropdown from './Education';
import OccupationDropdown from "./Occupation";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import UpdateDetailsResponse from "../model/response/UpdateDetailsResponse";
import UpdateDetails from "../model/request/UpdateDetails";
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { Oval } from "react-loader-spinner";


function Professional() {
    var location = useLocation();
    var { profile } = location.state || {};

    const [activeuser, setActiveUser] = useState([]);
    const [educationDetails, setEducationdetails] = useState(profile.education_in_Detail);
    const [college, setCollege] = useState(profile.institution);
    const [employed_In, setEmployedIn] = useState(profile.employed_InId);
    const [highesteducation, setHighestEducation] = useState(profile.education_CategoryId);
    const [occupation, setOccupation] = useState(profile.occupationId);
    const [salary, setSalary] = useState(profile.fromIncome_id);

    const [isLoading, setIsLoading] = useState(false)

    const navigation = useNavigate()

    function clicktoEditprofile() {
        navigation('/Editprofile')
        setIsLoading(true);
    }

    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }


    useEffect(() => {

    }, []);

    function ProfessionalAPICall() {

        setIsLoading(true);

        var request = new UpdateDetails();

        request.education = parseInt(highesteducation);
        request.employedIn = parseInt(employed_In);
        request.occupation = parseInt(occupation);
        // request.highesteducation = parseInt(highesteducation);
        request.institution = college;
        request.user_Id = loginVal.user_Id;
        request.from_Income = parseInt(salary);


        console.log("Response:", JSON.stringify(request));
        axios.put(
            ApiConfig.getUrl("User/updateProfessional"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);
                //  console.log("statusCode:", login.user_Id);

                const profileVal = UpdateDetailsResponse.fromJson(api.response);

                console.log("Response:", JSON.stringify(profileVal));
                setActiveUser(profileVal);
                showToast("Update successfull");
                setIsLoading(false);




            })
            .catch(error => {
                console.error("Error:", error);
                showToastFailed("Update Error");
                setIsLoading(false);
            });
    }
    const handleEducationChange = (x) => {
        console.log(x); // ← you will see a NUMBER
        setHighestEducation(x);

    };

    const handleOccupationChange = (x) => {
        console.log(x); // ← you will see a NUMBER
        setOccupation(x);
    };


    const disableRightClick = (e) => {
        if (ApiConfig.ENV == "PRD") {
            e.preventDefault();
        }
    };
    return (
        <div onContextMenu={disableRightClick}>
            <ToastContainer />


            <div className="fullview" style={{ fontFamily: " font-family: Arial, Helvetica, sans-serif" }}>
                {isLoading && (
                    <div className="loader-overlay">
                        <Oval
                            height={60}
                            width={60}
                            color="#ffffff"
                            secondaryColor="#cccccc"
                            strokeWidth={4}
                            visible={true}
                        />
                    </div>
                )}
                < div className="container border p-5">
                    <div className='topic-row '>
                        <h2>Professional information</h2>
                        <button className="Edit-btn" onClick={clicktoEditprofile}>Close</button></div>

                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="education" className="education" >Highest Education :</label></div>
                        <div className="w-100">
                            <EducationDropdown value={highesteducation} onChange={handleEducationChange} />
                        </div>
                    </div>

                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="education" className="education" >Education in Detail :</label></div>
                        <div className=" w-100 "><input type="text" className="input_box " style={{ width: "100%" }} value={educationDetails} onChange={(e) => setEducationdetails(e.target.value)} /></div></div>

                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="College" className="College" >College / Institution :</label></div>
                        <div className=" w-100 "><input type="text" placeholder="Enter College/Institution Name " className="input_box w-100"
                            value={college} onChange={(e) => setCollege(e.target.value)} /></div></div>


                    <div className="card-row">
                        <div className="left-label">
                            <label htmlFor="Employed" id="Employed">
                                Employed in:
                            </label>
                        </div>

                        <div className="w-100">
                            <select
                                id="Employed"
                                className="input_box w-100"
                                value={employed_In}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setEmployedIn(value);

                                    if (value === "6") {
                                        setOccupation("140");
                                        setSalary("28");
                                    } else {
                                        setOccupation("");
                                        setSalary("");
                                    }
                                }}
                            >
                                <option value="1">Government/PSU</option>
                                <option value="2">Defence</option>
                                <option value="3">Private</option>
                                <option value="4">Business</option>
                                <option value="5">Self</option>
                                <option value="6">Not Working</option>
                            </select>
                        </div>
                    </div>


                    {/* Occupation */}
                    {String(employed_In) !== "6" && (
                        <div className="card-row">
                            <div className="left-label">
                                <label htmlFor="Occupation" className="Occupation">
                                    Occupation :
                                </label>
                            </div>

                            <div className="w-100">
                                <OccupationDropdown
                                    value={occupation}
                                    onChange={handleOccupationChange}
                                />
                            </div>
                        </div>
                    )}


                    {/* Salary */}
                   {String(employed_In) !== "6" && (
    <div className="card-row">
        <div className="left-label">
            <label htmlFor="Salary" className="Salary">
                Salary :
            </label>
        </div>

        <div className="w-100">
            <select
                id="income"
                className="input_box w-100"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
            >
                <option value="">Select Salary</option>
                <option value="1">0 - 1 Lakh</option>
                <option value="2">1 - 2 Lakh</option>
                <option value="3">2 - 3 Lakhs</option>
                <option value="4">3 - 4 Lakhs</option>
                <option value="5">4 - 5 Lakhs</option>
                <option value="6">5 - 6 Lakhs</option>
                <option value="7">6 - 7 Lakhs</option>
                <option value="8">7 - 8 Lakhs</option>
                <option value="9">8 - 9 Lakhs</option>
                <option value="10">9 - 10 Lakhs</option>
                <option value="11">10 - 12 Lakhs</option>
                <option value="12">12 - 14 Lakhs</option>
                <option value="13">14 - 16 Lakhs</option>
                <option value="14">16 - 18 Lakhs</option>
                <option value="15">18 - 20 Lakhs</option>
                <option value="16">20 - 25 Lakhs</option>
                <option value="17">25 - 30 Lakhs</option>
                <option value="18">30 - 35 Lakhs</option>
                <option value="19">35 - 40 Lakhs</option>
                <option value="20">40 - 45 Lakhs</option>
                <option value="21">45 - 50 Lakhs</option>
                <option value="22">50 to 60 Lakhs</option>
                <option value="23">60 - 70 Lakhs</option>
                <option value="24">70 - 80 Lakhs</option>
                <option value="25">80 - 90 Lakhs</option>
                <option value="26">90 Lakhs - 1 Crore</option>
                <option value="27">1 Crore & Above</option>
            </select>
        </div>
    </div>
)}

                    <div className="btn-group mt-3">
                        <button style={{ backgroundColor: "var(--primary-color)" }} onClick={ProfessionalAPICall} className="btn">Save</button>
                        <button style={{ backgroundColor: "lightgrey" }} className="btn" onClick={clicktoEditprofile}> Cancel</button>
                    </div>

                </div>
            </div>
            <footer className='bg-dark text-white text-center'>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </div>
    );
}
export default Professional;